import Bold from '@tiptap/extension-bold'
// Option 2: Browser-only (lightweight)
// import { generateHTML } from '@tiptap/core'
import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import ListItem from '@tiptap/extension-list-item'
import Text from '@tiptap/extension-text'
// Option 1: Browser + server-side
import { generateHTML, type JSONContent } from '@tiptap/core'
import { useMemo } from 'react'
import BulletList from '@tiptap/extension-bullet-list'
import OrderedList from '@tiptap/extension-ordered-list'
import Italic from '@tiptap/extension-italic'
import Heading1 from '@tiptap/extension-heading'
import Strike from '@tiptap/extension-strike'
import Blockquote from '@tiptap/extension-blockquote'
import HorizontalRule from '@tiptap/extension-horizontal-rule'
import Underline from '@tiptap/extension-underline'
import { TextStyle } from '@tiptap/extension-text-style'

interface TiptapJsonToHtmlProps {
    json: string
}

export default ({ json }: TiptapJsonToHtmlProps) => {
    const parsed = useMemo(() => {
        try {
            return JSON.parse(json) as JSONContent
        } catch {
            // fallback to an empty document if parsing fails
            return { type: 'doc', content: [
                { type: 'paragraph', content: [
                    { type: 'text', text: json ?? ''}
                ] }
            ] } as JSONContent
        }
    }, [json])

    const output = useMemo(() => {
        return generateHTML(parsed, [
            Document,
            Paragraph,
            Text,
            Bold,
            ListItem,
            BulletList,
            OrderedList,
            Heading1,
            Italic,
            Strike,
            Blockquote,
            HorizontalRule,
            Underline,
            TextStyle,
        ])
    }, [parsed])

    return (
        <div className="tiptap" dangerouslySetInnerHTML={{ __html: output }} />
    )
}